export default "__VITE_ASSET__BNz4bwC5__"